import type { PostImpersonateContext } from "./postImpersonateRedirect.types";

export type { PostImpersonateContext } from "./postImpersonateRedirect.types";

/**
 * Target path on the Angular admin host after PMC impersonation + /api/verify?force.
 *
 * Angular always does location.href = 'dashboard' (or 'resident-application/active' for ROLE_RENTER).
 * There is NO role-based redirect to property/company edit pages after impersonation.
 */
export function getPostImpersonateAngularPath(
  userData: Record<string, unknown>,
  _ctx?: PostImpersonateContext,
): string {
  const role = userData.current_role as Record<string, unknown> | undefined;
  const roleName = (role?.role_name as string) || "";

  if (roleName === "ROLE_RENTER") {
    return "/resident-application/active";
  }

  return "/dashboard";
}

/**
 * In-app routes after PMC impersonation (React Router under /dashboard, etc.).
 *
 * Angular always does location.href = 'dashboard' (or 'resident-application/active' for ROLE_RENTER).
 * There is NO role-based redirect to property/company edit pages after impersonation in Angular.
 */
export function getPostImpersonateReactPath(
  userData: Record<string, unknown>,
  _ctx?: PostImpersonateContext,
): string {
  const role = userData.current_role as Record<string, unknown> | undefined;
  const roleName = (role?.role_name as string) || "";

  if (roleName === "ROLE_RENTER") {
    return "/resident-application/active";
  }

  return "/dashboard";
}
